<template>
  <Article :title="title" :subtitle="subtitle" :header="false">
    <!-- <section class="kc-elm kc-css-911125 kc_row">
      <div class="kc-row-container kc-container">
        <div class="kc-wrap-columns">
          <div class="kc-elm kc-css-225715 kc_col-sm-12 kc_column kc_col-sm-12">
            <div class="kc-col-container">
              <div class="ssc_mltttl kc-elm kc-css-512028">
                <h2 class="wr deb derb dea dera none nonea">
                  <span class="t1">Industries and </span>
                  <span class="t2">Verticals</span>
                </h2>
              </div>
              <div class="kc-elm kc-css-63077 kc_text_block">
                <p>The GDPR will apply in the UK from 25th May 2018 despite Brexit. You will need to review the way your process information on parents, children and staff. You will also need to update your “Privacy and Confidentiality Policy” and make an amendment to your contract. You should share your new privacy notice with parents who already use your setting and get them to sign the amendment to your contract.</p>
                <h2>
                  <strong>You should:</strong>
                </h2>
                <ul>
                  <li>Make a list of all the personal information that you store on parents, children and staff in your setting.</li>
                  <li>Check that the personal information and data you hold on people is:</li>
                  <li>Up to date and accurate</li>
                  <li>Kept secure</li>
                  <li>Adequate, relevant and not excessive</li>
                  <li>Lawfully processed (see below)</li>
                  <li>Only kept for as long as necessary</li>
                  <li>If you have staff, make sure that they are also aware of your processes regarding personal information.</li>
                </ul>
                <h2>
                  <strong>You should: Update your Privacy Notice</strong>
                </h2>
                <p>Update your Privacy Notice and permissions from parents to include information about how the data you hold on people is being lawfully processed. Here is a sample privacy policy you can adapt for your setting:</p>
                <p>
                  <strong>Confidentiality and Privacy Policy</strong>
                </p>
                <p>In order to work as your childminder I am legally obliged to collect certain information about you and your child to comply with the requirements of the EYFS and to maintain accounts and records. Other information that I collect is not a legal requirement but will help me to do my job as your childminder. I will need to process information such as: personal details, family details, life style and social circumstances, financial details, GP contact details, inoculation details, allergy details and digital photographs. I also process sensitive classes of information that may include racial or ethnic origin, religious or other beliefs, and physical or mental health details. I have a legal requirement to collect and process some of this personal information about you and your child. I need you to sign to say that you are happy for me to collect and process the non-statutory information I need to best look after your child.</p>
                <p>All information on children and families is kept securely and treated in confidence. I am registered with the Information Commissioner’s Office (ICO) and am aware of my responsibilities under General Data Protection Regulations (GDPR). In general, the confidential information I have on file will only be shared if you give permission or there appears to be a child protection issue. I will only share information about your child with you or your child’s other carers, other professionals working with your child, or with the police, social services, local or central government including Ofsted.&nbsp; All details will be kept confidential and records are kept secure. You have a right to access any of the information that I hold on you or your child at any time.</p>
                <p>If your child attends nursery or another setting while in my care, or arrives from nursery, school or another setting, then we will need to be able to share appropriate information between each other. This two way flow of information will help your child to make the transition between carers. It will also keep you informed about anything you need to know that you weren’t there to hear yourself. You will need to sign to say you are happy for me to share information about your child in this way, and to pass along any information I learn to you.</p>
                <p>When your child leaves my setting I will only store information on you or your child for as long as is necessary. Anything I don’t need to keep I will delete from my computer or shred. I may hold onto some photographs for my own personal use in albums or displayed in my house. Your child’s learning journey will be sent home with you on your last day.</p>
                <p>If you have any complaints with the way you feel I have handled any of your personal data, please speak to me in the first instance so that we can resolve the complaint. You have the right to complain to the Information Commissioners Officer (ICO) if you feel I have not resolved the complaint to your satisfaction.</p>
                <p>Here is a sample permission box you could ask parents to complete. If you use my Contracts, Policies and Forms, you would add this as an amendment to your Contract and make sure that all the parents who use your setting have signed it:</p>
                <p>____ I give permission for the childminder to collect and process non-statutory information about my child such as the name of my child’s GP, interests, likes and dislikes etc, as well as sensitive classes of information including your child’s racial or ethnic origin, religious or other beliefs, and physical or mental health details. This information will be kept confidential.</p>
                <h2>
                  <strong>You should: Register with the Information Commissioners Office (ICO)</strong>
                </h2>
                <p>In the past many childminders have got out of registering with the ICO because it was felt that the ICO only cared about the storing of digital photographs. Childminders could get out of paying by saying, “I don’t need to register as I don’t store photos on my computer; I print then delete.”</p>
                <p>The GDPR requires “every organisation that processes personal information must register with the ICO”.&nbsp; So the wriggle room to avoid the ICO registration fee has gone. ALL childminders will need to register with the ICO because all childminders must legally record and store personal information as a requirement of the EYFS statutory framework. Information about registering with the ICO as a childminder is here.</p>
                <p>Many councils are putting on training sessions for childminders and I recommend you take one if you can. For general information from the ICO about GDPR read Preparing for the GDPR: 12 steps to take now. This is one of the most useful articles I have read so far that is specifically written for early years providers.</p>
                <p>
                  <em>Please note that the information I’m presenting to you here is correct to the best of my knowledge but I am not an expert. If your council tells you something that directly contradicts something I’ve written here, please do as they say and most importantly TELL ME so that I can correct the information that I am sharing with others. Thank you.</em>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section> -->
   <section class="kc-elm kc-css-909007 kc_row">
   <div class="befbgr" data-ssc-svg="" data-ssc-img-s="" data-ssc-img-anim=""></div>
   <div class="befbgr" data-ssc-svg="" data-ssc-img-s="" data-ssc-img-anim=""></div>
   <div class="aftbgr" data-ssc-svg="" data-ssc-img-s="" data-ssc-img-anim=""></div>
   <div class="aftbgr" data-ssc-svg="" data-ssc-img-s="" data-ssc-img-anim=""></div>
   <div class="befbgr5" data-ssc-svg="" data-ssc-img-s="" data-ssc-img-anim=""></div>
   <div class="befbgr6" data-ssc-svg="" data-ssc-img-s="" data-ssc-img-anim=""></div>
   <div class="aftbgr7" data-ssc-svg="" data-ssc-img-s="" data-ssc-img-anim=""></div>
   <div class="aftbgr8" data-ssc-svg="" data-ssc-img-s="" data-ssc-img-anim=""></div>
   <div class="kc-row-container  kc-container">
      <div class="kc-wrap-columns">
         <div class="kc-elm kc-css-478371 kc_col-sm-12 kc_column kc_col-sm-12">
            <div class="kc-col-container">
               <div class="ssc_mltttl  kc-elm kc-css-731423 ">
                  <div class="wr deb derb dea dera none nonea">
                     <h2 class="t1">{{$t('industries_page.text_1')}} </h2>
                     <h2 class="t2"> {{$t('industries_page.text_2')}}</h2>
                     <p class="t4">{{$t('industries_page.text_3')}}</p>
                  </div>
               </div>
               <div class="kc-elm kc-css-93029 kc_row kc_row_inner sst-flex-row-inner kc-pc-loaded">
                  <div class="kc-elm kc-css-696606 kc_col-sm-3 kc_column_inner kc_col-sm-3">
                     <div class="kc_wrapper kc-col-inner-container wow animated bounceInUp" data-wow-duration="1s" data-wow-delay="0s">
                        <div class="ssc_icon_box kc-elm kc-css-1992 template3 ">
                           <div class="cont_box">
                              <div class="title">{{$t('industries_page.text_4')}}</div>
                              <div class="description lines0">{{$t('industries_page.text_5')}}</div>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div class="kc-elm kc-css-937967 kc_col-sm-3 kc_column_inner kc_col-sm-3">
                     <div class="kc_wrapper kc-col-inner-container wow animated bounceInUp" data-wow-duration="1s" data-wow-delay="0s">
                        <div class="ssc_icon_box kc-elm kc-css-314469 template3 ">
                        
                           <div class="cont_box">
                              <div class="title">{{$t('industries_page.text_6')}}</div>
                              <div class="description lines0">{{$t('industries_page.text_7')}}</div>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div class="kc-elm kc-css-118172 kc_col-sm-3 kc_column_inner kc_col-sm-3">
                     <div class="kc_wrapper kc-col-inner-container wow animated bounceInUp" data-wow-duration="1s" data-wow-delay="0s">
                        <div class="ssc_icon_box kc-elm kc-css-296278 template3 ">
                           
                           <div class="cont_box">
                              <div class="title">{{$t('industries_page.text_8')}}</div>
                              <div class="description lines0">{{$t('industries_page.text_9')}}</div>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div class="kc-elm kc-css-757130 kc_col-sm-3 kc_column_inner kc_col-sm-3">
                     <div class="kc_wrapper kc-col-inner-container wow animated bounceInUp" data-wow-duration="1s" data-wow-delay="0s">
                        <div class="ssc_icon_box kc-elm kc-css-942737 template3 ">
                           
                           <div class="cont_box">
                              <div class="title">{{$t('industries_page.text_10')}}</div>
                              <div class="description lines0">{{$t('industries_page.text_11')}}</div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
               <div class="kc-elm kc-css-93029 kc_row kc_row_inner sst-flex-row-inner kc-pc-loaded">
                  <div class="kc-elm kc-css-696606 kc_col-sm-3 kc_column_inner kc_col-sm-3">
                     <div class="kc_wrapper kc-col-inner-container wow animated bounceInUp" data-wow-duration="1s" data-wow-delay="0s">
                        <div class="ssc_icon_box kc-elm kc-css-1992 template3 ">
                           <div class="cont_box">
                              <div class="title">{{$t('industries_page.text_12')}}</div>
                              <div class="description lines0">{{$t('industries_page.text_13')}}</div>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div class="kc-elm kc-css-937967 kc_col-sm-3 kc_column_inner kc_col-sm-3">
                     <div class="kc_wrapper kc-col-inner-container wow animated bounceInUp" data-wow-duration="1s" data-wow-delay="0s">
                        <div class="ssc_icon_box kc-elm kc-css-314469 template3 ">
                        
                           <div class="cont_box">
                              <div class="title">{{$t('industries_page.text_14')}}</div>
                              <div class="description lines0">{{$t('industries_page.text_15')}}</div>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div class="kc-elm kc-css-118172 kc_col-sm-3 kc_column_inner kc_col-sm-3">
                     <div class="kc_wrapper kc-col-inner-container wow animated bounceInUp" data-wow-duration="1s" data-wow-delay="0s">
                        <div class="ssc_icon_box kc-elm kc-css-296278 template3 ">
                           
                           <div class="cont_box">
                              <div class="title">{{$t('industries_page.text_16')}}</div>
                              <div class="description lines0">{{$t('industries_page.text_17')}}</div>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div class="kc-elm kc-css-757130 kc_col-sm-3 kc_column_inner kc_col-sm-3">
                     <div class="kc_wrapper kc-col-inner-container wow animated bounceInUp" data-wow-duration="1s" data-wow-delay="0s">
                        <div class="ssc_icon_box kc-elm kc-css-942737 template3 ">
                           
                           <div class="cont_box">
                              <div class="title">{{$t('industries_page.text_18')}}</div>
                              <div class="description lines0">{{$t('industries_page.text_19')}}</div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
               <div class="kc-elm kc-css-93029 kc_row kc_row_inner sst-flex-row-inner kc-pc-loaded">
                  <div class="kc-elm kc-css-696606 kc_col-sm-3 kc_column_inner kc_col-sm-3">
                     <div class="kc_wrapper kc-col-inner-container wow animated bounceInUp" data-wow-duration="1s" data-wow-delay="0s">
                        <div class="ssc_icon_box kc-elm kc-css-1992 template3 ">
                           <div class="cont_box">
                              <div class="title">{{$t('industries_page.text_20')}}</div>
                              <div class="description lines0">{{$t('industries_page.text_21')}}</div>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div class="kc-elm kc-css-937967 kc_col-sm-3 kc_column_inner kc_col-sm-3">
                     <div class="kc_wrapper kc-col-inner-container wow animated bounceInUp" data-wow-duration="1s" data-wow-delay="0s">
                        <div class="ssc_icon_box kc-elm kc-css-314469 template3 ">
                        
                           <div class="cont_box">
                              <div class="title">{{$t('industries_page.text_22')}}</div>
                              <div class="description lines0">{{$t('industries_page.text_23')}}</div>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div class="kc-elm kc-css-118172 kc_col-sm-3 kc_column_inner kc_col-sm-3">
                     <div class="kc_wrapper kc-col-inner-container wow animated bounceInUp" data-wow-duration="1s" data-wow-delay="0s">
                        <div class="ssc_icon_box kc-elm kc-css-296278 template3 ">
                           
                           <div class="cont_box">
                              <div class="title">{{$t('industries_page.text_24')}}</div>
                              <div class="description lines0">{{$t('industries_page.text_25')}}</div>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div class="kc-elm kc-css-757130 kc_col-sm-3 kc_column_inner kc_col-sm-3">
                     <div class="kc_wrapper kc-col-inner-container wow animated bounceInUp" data-wow-duration="1s" data-wow-delay="0s">
                        <div class="ssc_icon_box kc-elm kc-css-942737 template3 ">
                           
                           <div class="cont_box">
                              <div class="title">{{$t('industries_page.text_26')}}</div>
                              <div class="description lines0">{{$t('industries_page.text_27')}}</div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
               <div class="kc-elm kc-css-93029 kc_row kc_row_inner sst-flex-row-inner kc-pc-loaded">
                  <div class="kc-elm kc-css-696606 kc_col-sm-3 kc_column_inner kc_col-sm-3">
                     <div class="kc_wrapper kc-col-inner-container wow animated bounceInUp" data-wow-duration="1s" data-wow-delay="0s">
                        <div class="ssc_icon_box kc-elm kc-css-1992 template3 ">
                           <div class="cont_box">
                              <div class="title">{{$t('industries_page.text_28')}}</div>
                              <div class="description lines0">{{$t('industries_page.text_29')}}</div>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div class="kc-elm kc-css-937967 kc_col-sm-3 kc_column_inner kc_col-sm-3">
                     <div class="kc_wrapper kc-col-inner-container wow animated bounceInUp" data-wow-duration="1s" data-wow-delay="0s">
                        <div class="ssc_icon_box kc-elm kc-css-314469 template3 ">
                        
                           <div class="cont_box">
                              <div class="title">{{$t('industries_page.text_30')}}</div>
                              <div class="description lines0">{{$t('industries_page.text_31')}}</div>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div class="kc-elm kc-css-118172 kc_col-sm-3 kc_column_inner kc_col-sm-3">
                     <div class="kc_wrapper kc-col-inner-container wow animated bounceInUp" data-wow-duration="1s" data-wow-delay="0s">
                        <div class="ssc_icon_box kc-elm kc-css-296278 template3 ">
                           
                           <div class="cont_box">
                              <div class="title">{{$t('industries_page.text_32')}}</div>
                              <div class="description lines0">{{$t('industries_page.text_33')}}</div>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div class="kc-elm kc-css-757130 kc_col-sm-3 kc_column_inner kc_col-sm-3">
                     <div class="kc_wrapper kc-col-inner-container wow animated bounceInUp" data-wow-duration="1s" data-wow-delay="0s">
                        <div class="ssc_icon_box kc-elm kc-css-942737 template3 ">
                           
                           <div class="cont_box">
                              <div class="title">{{$t('industries_page.text_34')}}</div>
                              <div class="description lines0">{{$t('industries_page.text_35')}}</div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
               <div class="kc-elm kc-css-34556 kc_row kc_row_inner sst-flex-row-inner kc-pc-loaded">
                  <div class="kc-elm kc-css-873504 kc_col-sm-3 kc_column_inner kc_col-sm-3">
                     <div class="kc_wrapper kc-col-inner-container wow animated bounceInUp" data-wow-duration="1s" data-wow-delay="0s">
                        <div class="ssc_icon_box kc-elm kc-css-802933 template3 ">
                           <div class="cont_box">
                              <div class="title">{{$t('industries_page.text_36')}}</div>
                              <div class="description lines0">{{$t('industries_page.text_37')}}</div>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div class="kc-elm kc-css-339992 kc_col-sm-3 kc_column_inner kc_col-sm-3">
                     <div class="kc_wrapper kc-col-inner-container wow animated bounceInUp" data-wow-duration="1s" data-wow-delay="0s">
                        <div class="ssc_icon_box kc-elm kc-css-361435 template3 ">
                           
                           <div class="cont_box">
                              <div class="title">{{$t('industries_page.text_38')}}</div>
                              <div class="description lines0">{{$t('industries_page.text_39')}}</div>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div class="kc-elm kc-css-920217 kc_col-sm-3 kc_column_inner kc_col-sm-3">
                     <div class="kc_wrapper kc-col-inner-container wow animated bounceInUp" data-wow-duration="1s" data-wow-delay="0s">
                        <div class="ssc_icon_box kc-elm kc-css-867326 template3 ">
                           
                           <div class="cont_box">
                              <div class="title">{{$t('industries_page.text_40')}}</div>
                              <div class="description lines0">{{$t('industries_page.text_41')}}</div>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div class="kc-elm kc-css-334574 kc_col-sm-3 kc_column_inner kc_col-sm-3">
                     <div class="kc_wrapper kc-col-inner-container wow animated bounceInUp" data-wow-duration="1s" data-wow-delay="0s">
                        <div class="ssc_icon_box kc-elm kc-css-540748 template3 ">
                           
                           <div class="cont_box">
                              <div class="title">{{$t('industries_page.text_42')}}</div>
                              <div class="description lines0">{{$t('industries_page.text_43')}}</div>
                           </div>
                        </div>
                     </div>
                  </div>
                  
                  
               </div>
               <div class="kc-elm kc-css-93029 kc_row kc_row_inner sst-flex-row-inner kc-pc-loaded">
                  <div class="kc-elm kc-css-334574 kc_col-sm-3 kc_column_inner kc_col-sm-3">
                     <div class="kc_wrapper kc-col-inner-container wow animated bounceInUp" data-wow-duration="1s" data-wow-delay="0s">
                        <div class="ssc_icon_box kc-elm kc-css-540748 template3 ">
                           
                           <div class="cont_box">
                              <div class="title">{{$t('industries_page.text_44')}}</div>
                              <div class="description lines0">{{$t('industries_page.text_45')}}</div>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div class="kc-elm kc-css-334574 kc_col-sm-3 kc_column_inner kc_col-sm-3">
                     <div class="kc_wrapper kc-col-inner-container wow animated bounceInUp" data-wow-duration="1s" data-wow-delay="0s">
                        <div class="ssc_icon_box kc-elm kc-css-540748 template3 ">
                           
                           <div class="cont_box">
                              <div class="title">{{$t('industries_page.text_46')}}</div>
                              <div class="description lines0">{{$t('industries_page.text_47')}}</div>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div class="kc-elm kc-css-334574 kc_col-sm-3 kc_column_inner kc_col-sm-3">
                     <div class="kc_wrapper kc-col-inner-container wow animated bounceInUp" data-wow-duration="1s" data-wow-delay="0s">
                        <div class="ssc_icon_box kc-elm kc-css-540748 template3 ">
                           
                           <div class="cont_box">
                              <div class="title">{{$t('industries_page.text_48')}}</div>
                              <div class="description lines0">{{$t('industries_page.text_49')}}</div>
                           </div>
                        </div>
                     </div>
                  </div>
                  
               </div>
            </div>
         </div>
      </div>
   </div>
   </section>
  </Article>
</template>

<script>
import Article from "@/components/layout/Article";

export default {
  name: "IndustriesandVerticals",
  components: {
    Article
  },
  data() {
    return {
      title: "IndustriesandVerticals",
      subtitle: "GDPR"
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.ssc-subtitle {
  color: #ffffff;
}

.ssc_icon_box{
  background-color: #ffffff !important;
}

.description{
  text-align: justify !important;
  margin-top: 20px;
}

@media all{
*,.kc-col-container,.kc-container,.kc-elm{box-sizing:border-box;}
div{display:block;}
.kc-elm{float:left;width:100%;}
.kc_col-sm-3{width:25%;}
.kc_col-sm-12{width:100%;}
.kc-container{width:100%;max-width:1425px;margin:0 auto;padding-left:15px;padding-right:15px;}
.kc_row:not(.kc_row_inner){clear:both;float:left;width:100%;}
.kc-row-container.kc-container .kc-wrap-columns,.kc_row_inner{margin-left:-15px;margin-right:-15px;clear:both;}
.kc_row.kc_row_inner{width:calc(100% + 30px);}
.kc_column,.kc_column_inner{min-height:1px;position:relative;padding-right:15px;padding-left:15px;float:left;}
.kc_column>.kc-col-container,.kc_column_inner>.kc-col-inner-container{height:100%;}
.kingcomposer div.kc_column,.kingcomposer div.kc_column_inner{clear:none;}
.kc-col-container{clear:both;display:block;width:100%;}
@media screen and (min-width:999px){
.kc-row-container .kc-wrap-columns,.kc_row_inner{display:-webkit-flex;display:-ms-flexbox;display:flex;width:100%;flex-wrap:wrap;}
.kc-row-container.kc-container .kc-wrap-columns,.kc_row_inner{width:calc(100% + 30px);}
}
@media screen and (max-width:767px){
body.kc-css-system .kc_column,body.kc-css-system .kc_column_inner{width:100%;}
div.kc_row{display:block;}
}
[class^="nat-"]{font-family:'native'!important;speak:none;font-style:normal;font-weight:400;font-variant:normal;text-transform:none;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;}
.nat-cirleborder:before{content:"\ebd0";}
*{box-sizing:border-box;}
*:before,*:after{box-sizing:border-box;}
div:focus,i:focus{outline:none;}
section{display:block;}
svg:not(:root){overflow:hidden;}
h2{font-family:"Montserrat";color:#222;font-weight:500;font-size:40px;line-height:52px;text-transform:full-size-kana;text-align:left;margin:20px 0 15px 0;}
p{margin:10px 0 25px 0;}
.page p{line-height:29px;}
i{font-style:italic;}
*,*:before,*:after{box-sizing:inherit;}
.kc_row.kc_row_inner:focus{outline:none;}
.kc-row-container:after{content:"";display:block;clear:both;}
.kc-col-container>div{position:relative;}
@media screen and (max-width:601px){
h2{font-family:"Montserrat";color:#222;font-weight:500;font-size:30px;line-height:34px;text-transform:none;text-align:center;}
p{margin:10px 0 25px 0;line-height:26px;}
h2{font-family:"Montserrat";color:#222;font-weight:500;font-size:30px;line-height:34px;text-transform:none;text-align:center;margin:20px 0;}
}
section{position:relative;}
.befbgr,.befbgr5,.befbgr6{position:absolute;top:0;left:0;width:100%;line-height:0;transition:all 300ms;}
.aftbgr,.aftbgr7,.aftbgr8{position:absolute;bottom:0;left:0;width:100%;line-height:0;transition:all 300ms;}
.c_svg{display:table;z-index:2;position:relative;}
.c_svg div{display:table-cell;width:100%;vertical-align:middle;}
.c_svg svg{max-width:100%;max-height:100%;}
.ssc_icon_box.kc-elm{margin-bottom:10px;width:auto;}
.ssc_icon_box:after{content:"";display:block;clear:both;}
.ssc_icon_box i{transition:all 300ms ease-in;}
.ssc_icon_box,.ssc_icon_box .bgr_icon,.ssc_icon_box .bgr_icon i,.ssc_icon_box .icon_box,.ssc_icon_box .cont_box,.ssc_icon_box .title,.ssc_icon_box .cont_box .description,.ssc_icon_box .c_svg{transition:all 350ms ease-in;}
.ssc_icon_box.template3{text-align:center;}
.ssc_icon_box.template3 .title{margin-top:20px;}
.ssc_icon_box.template3 .bgr_icon i{margin:0 auto;}
.ssc_icon_box.template3 .c_svg{margin-left:auto;margin-right:auto;}
.ssc_icon_box.template3 .icon_box{width:100%;}
.ssc_icon_box .bgr_icon{position:relative;z-index:1;}
.ssc_icon_box .bgr_icon i{display:block;}
.ssc_icon_box .icon_box{width:10px;}
.ssc_icon_box .cont_box{vertical-align:top;}
.ssc_icon_box .title{margin-bottom:2px;font-size:20px;font-weight:700;}
.ssc_icon_box .cont_box .description{line-height:1.4em;}
.main [class*="lines"]{display:-webkit-box!important;-webkit-box-orient:vertical;overflow:hidden;}
@media screen and (max-width:1024px){
.befbgr,.befbgr5,.befbgr6,.aftbgr,.aftbgr7,.aftbgr8{overflow:hidden;}
}
@media screen and (max-width:480px){
.ssc_icon_box .bgr_icon i{margin-left:auto;margin-right:auto;}
.ssc_icon_box .icon_box{text-align:center;}
}
.ssc_mltttl .wr p{margin:0;}
.ssc_mltttl>div{display:block;width:auto;position:relative;}
.deb:before,.dea:after{position:absolute;content:'';display:block;top:0;transition:all 400ms;}
.deb.none:before,.dea.nonea:after{content:none;}
.derb:before,.dera:after{right:0;}
.kc-col-container:after{content:"";display:block;clear:both;}
.sst-flex-row-inner{position:relative;z-index:1;min-height:30px;}
}
/*! CSS Used from: Embedded */
@media (max-width: 479px){
h2{font-size:30px;line-height:34px!important;}
p.t4{font-size:20px;line-height:26px;padding-top:20px!important;}
}
/*! CSS Used from: Embedded */
.kc-container{max-width:1425px;}
/*! CSS Used from: Embedded */
@media only screen and (min-width:1000px) and (max-width:5000px){
body.kc-css-system .kc-css-478371{width:100%;}
body.kc-css-system .kc-css-696606{width:25%;}
body.kc-css-system .kc-css-937967{width:25%;}
body.kc-css-system .kc-css-118172{width:25%;}
body.kc-css-system .kc-css-757130{width:25%;}
body.kc-css-system .kc-css-873504{width:25%;}
body.kc-css-system .kc-css-339992{width:25%;}
body.kc-css-system .kc-css-920217{width:25%;}
body.kc-css-system .kc-css-334574{width:25%;}
}
body.kc-css-system .kc-css-909007{padding-top:30px;padding-bottom:110px;}
body.kc-css-system .kc-css-731423.ssc_mltttl .wr{text-align:center;}
body.kc-css-system .kc-css-731423{text-align:center;margin-bottom:0px;padding-top:30px;padding-bottom:30px;display:inline-block;}
body.kc-css-system .kc-css-731423 .deb:before{border-radius:50px 50px 50px 50px;width:40px;height:40px;margin-top:10px;margin-right:-5px;}
body.kc-css-system .kc-css-731423 .deb:after{border-radius:20px 20px 20px 20px;width:8px;height:8px;margin-top:25px;margin-right:-10px;}
body.kc-css-system .kc-css-731423 .t1{line-height:45px;margin-bottom:0px;display:inline;}
body.kc-css-system .kc-css-731423 .t2{color:#ED7D31;line-height:45px;display:inline;}
body.kc-css-system .kc-css-731423 .t4{margin-top:25px;padding-right:26%;padding-left:26%;}
body.kc-css-system .kc-css-93029{padding-top:20px;padding-bottom:20px;}
.kc-css-93029 >.kc_column_inner{padding-left:15px;padding-right:15px;}
body.kc-css-system .kc-css-1992{width:300px;height: 380px;padding:33px 30px 27px 30px;border:1px solid #e4e7f2;border-radius:10px 10px 10px 10px;}
body.kc-css-system .kc-css-1992 .bgr_icon{color:#ED7D31;}
body.kc-css-system .kc-css-1992 .bgr_icon i{text-align:center;}
body.kc-css-system .kc-css-1992 .title{color:#222222;font-size:17px;line-height:25px;font-weight:500;text-transform:none;}
body.kc-css-system .kc-css-1992 .cont_box .description{color:#666666;font-size:17px;;margin-bottom:15px;}
body.kc-css-system .kc-css-1992 .cont_box .description{line-height:1.265em;}
body.kc-css-system .kc-css-1992 .icon_box{height:70px;}
body.kc-css-system .kc-css-1992 .c_svg{padding-top:calc((70px - 30px)/2);max-height:30px;width:30px;margin-top:-70px;}
body.kc-css-system .kc-css-1992 .c_svg svg{fill:#222222;}
body.kc-css-system .kc-css-1992 .c_svg div{height:30px;}
body.kc-css-system .kc-css-1992:hover .c_svg svg{fill:#ED7D31;}
body.kc-css-system .kc-css-314469{width:300px;height: 380px;padding:33px 30px 27px 30px;border:1px solid #e4e7f2;border-radius:10px 10px 10px 10px;}
body.kc-css-system .kc-css-314469 .bgr_icon{color:#ED7D31;}
body.kc-css-system .kc-css-314469 .bgr_icon i{text-align:center;}
body.kc-css-system .kc-css-314469 .title{color:#222222;font-size:17px;line-height:25px;font-weight:500;text-transform:none;}
body.kc-css-system .kc-css-314469 .cont_box .description{color:#666666;font-size:17px;;margin-bottom:15px;}
body.kc-css-system .kc-css-314469 .cont_box .description{line-height:1.265em;}
body.kc-css-system .kc-css-314469 .icon_box{height:70px;}
body.kc-css-system .kc-css-314469 .c_svg{padding-top:calc((70px - 30px)/2);max-height:30px;width:30px;margin-top:-70px;}
body.kc-css-system .kc-css-314469 .c_svg svg{fill:#222222;}
body.kc-css-system .kc-css-314469 .c_svg div{height:30px;}
body.kc-css-system .kc-css-314469:hover .c_svg svg{fill:#ED7D31;}
body.kc-css-system .kc-css-296278{width:300px;height: 380px;padding:33px 30px 27px 30px;border:1px solid #e4e7f2;border-radius:10px 10px 10px 10px;}
body.kc-css-system .kc-css-296278 .bgr_icon{color:#ED7D31;}
body.kc-css-system .kc-css-296278 .bgr_icon i{text-align:center;}
body.kc-css-system .kc-css-296278 .title{color:#222222;font-size:17px;line-height:25px;font-weight:500;text-transform:none;}
body.kc-css-system .kc-css-296278 .cont_box .description{color:#666666;font-size:17px;;margin-bottom:15px;}
body.kc-css-system .kc-css-296278 .cont_box .description{line-height:1.265em;}
body.kc-css-system .kc-css-296278 .icon_box{height:70px;}
body.kc-css-system .kc-css-296278 .c_svg{padding-top:calc((70px - 30px)/2);max-height:30px;width:30px;margin-top:-70px;}
body.kc-css-system .kc-css-296278 .c_svg svg{fill:#222222;}
body.kc-css-system .kc-css-296278 .c_svg div{height:30px;}
body.kc-css-system .kc-css-296278:hover .c_svg svg{fill:#ED7D31;}
body.kc-css-system .kc-css-942737{width:300px;height: 380px;padding:33px 30px 27px 30px;border:1px solid #e4e7f2;border-radius:10px 10px 10px 10px;}
body.kc-css-system .kc-css-942737 .bgr_icon{color:#ED7D31;}
body.kc-css-system .kc-css-942737 .bgr_icon i{text-align:center;}
body.kc-css-system .kc-css-942737 .title{color:#222222;font-size:17px;line-height:25px;font-weight:500;text-transform:none;}
body.kc-css-system .kc-css-942737 .cont_box .description{color:#666666;font-size:17px;;margin-bottom:15px;}
body.kc-css-system .kc-css-942737 .cont_box .description{line-height:1.265em;}
body.kc-css-system .kc-css-942737 .icon_box{height:70px;}
body.kc-css-system .kc-css-942737 .c_svg{padding-top:calc((70px - 30px)/2);max-height:30px;width:30px;margin-top:-70px;}
body.kc-css-system .kc-css-942737 .c_svg svg{fill:#222222;}
body.kc-css-system .kc-css-942737 .c_svg div{height:30px;}
body.kc-css-system .kc-css-942737:hover .c_svg svg{fill:#ED7D31;}
.kc-css-34556 >.kc_column_inner{padding-left:15px;padding-right:15px;}
body.kc-css-system .kc-css-802933{width:300px;height: 380px;padding:33px 30px 27px 30px;border:1px solid #e4e7f2;border-radius:10px 10px 10px 10px;}
body.kc-css-system .kc-css-802933 .bgr_icon{color:#ED7D31;}
body.kc-css-system .kc-css-802933 .bgr_icon i{text-align:center;}
body.kc-css-system .kc-css-802933 .title{color:#222222;font-size:17px;line-height:25px;font-weight:500;text-transform:none;}
body.kc-css-system .kc-css-802933 .cont_box .description{color:#666666;font-size:17px;;margin-bottom:15px;}
body.kc-css-system .kc-css-802933 .cont_box .description{line-height:1.265em;}
body.kc-css-system .kc-css-802933 .icon_box{height:70px;}
body.kc-css-system .kc-css-802933 .c_svg{padding-top:calc((70px - 30px)/2);max-height:30px;width:30px;margin-top:-70px;}
body.kc-css-system .kc-css-802933 .c_svg svg{fill:#222222;}
body.kc-css-system .kc-css-802933 .c_svg div{height:30px;}
body.kc-css-system .kc-css-802933:hover .c_svg svg{fill:#ED7D31;}
body.kc-css-system .kc-css-361435{width:300px;height: 380px;padding:33px 30px 27px 30px;border:1px solid #e4e7f2;border-radius:10px 10px 10px 10px;}
body.kc-css-system .kc-css-361435 .bgr_icon{color:#ED7D31;}
body.kc-css-system .kc-css-361435 .bgr_icon i{text-align:center;}
body.kc-css-system .kc-css-361435 .title{color:#222222;font-size:17px;line-height:25px;font-weight:500;text-transform:none;}
body.kc-css-system .kc-css-361435 .cont_box .description{color:#666666;font-size:17px;;margin-bottom:15px;}
body.kc-css-system .kc-css-361435 .cont_box .description{line-height:1.265em;}
body.kc-css-system .kc-css-361435 .icon_box{height:70px;}
body.kc-css-system .kc-css-361435 .c_svg{padding-top:calc((70px - 30px)/2);max-height:30px;width:30px;margin-top:-70px;}
body.kc-css-system .kc-css-361435 .c_svg svg{fill:#222222;}
body.kc-css-system .kc-css-361435 .c_svg div{height:30px;}
body.kc-css-system .kc-css-361435:hover .c_svg svg{fill:#ED7D31;}
body.kc-css-system .kc-css-867326{width:300px;height: 380px;padding:33px 30px 27px 30px;border:1px solid #e4e7f2;border-radius:10px 10px 10px 10px;}
body.kc-css-system .kc-css-867326 .bgr_icon{color:#ED7D31;}
body.kc-css-system .kc-css-867326 .bgr_icon i{text-align:center;}
body.kc-css-system .kc-css-867326 .title{color:#222222;font-size:17px;line-height:25px;font-weight:500;text-transform:none;}
body.kc-css-system .kc-css-867326 .cont_box .description{color:#666666;font-size:17px;;margin-bottom:15px;}
body.kc-css-system .kc-css-867326 .cont_box .description{line-height:1.265em;}
body.kc-css-system .kc-css-867326 .icon_box{height:70px;}
body.kc-css-system .kc-css-867326 .c_svg{padding-top:calc((70px - 30px)/2);max-height:30px;width:30px;margin-top:-70px;}
body.kc-css-system .kc-css-867326 .c_svg svg{fill:#222222;}
body.kc-css-system .kc-css-867326 .c_svg div{height:30px;}
body.kc-css-system .kc-css-867326:hover .c_svg svg{fill:#ED7D31;}
body.kc-css-system .kc-css-540748{width:300px;height: 380px;padding:33px 30px 27px 30px;border:1px solid #e4e7f2;border-radius:10px 10px 10px 10px;}
body.kc-css-system .kc-css-540748 .bgr_icon{color:#ED7D31;}
body.kc-css-system .kc-css-540748 .bgr_icon i{text-align:center;}
body.kc-css-system .kc-css-540748 .title{color:#222222;font-size:17px;line-height:25px;font-weight:500;text-transform:none;}
body.kc-css-system .kc-css-540748 .cont_box .description{color:#666666;font-size:17px;;margin-bottom:15px;}
body.kc-css-system .kc-css-540748 .cont_box .description{line-height:1.265em;}
body.kc-css-system .kc-css-540748 .icon_box{height:70px;}
body.kc-css-system .kc-css-540748 .c_svg{padding-top:calc((70px - 30px)/2);max-height:30px;width:30px;margin-top:-70px;}
body.kc-css-system .kc-css-540748 .c_svg svg{fill:#222222;}
body.kc-css-system .kc-css-540748 .c_svg div{height:30px;}
body.kc-css-system .kc-css-540748:hover .c_svg svg{fill:#ED7D31;}
@media only screen and (max-width:667px){
body.kc-css-system .kc-css-731423 .t4{padding-right:15px;padding-left:15px;}
}
@media only screen and (max-width:999px){
body.kc-css-system .kc-css-478371{margin-left:0%;width:100%;}
body.kc-css-system .kc-css-696606{margin-left:0%;width:100%;}
body.kc-css-system .kc-css-1992{width:100%;}
body.kc-css-system .kc-css-937967{margin-left:0%;width:100%;}
body.kc-css-system .kc-css-314469{width:100%;}
body.kc-css-system .kc-css-118172{margin-left:0%;width:100%;}
body.kc-css-system .kc-css-296278{width:100%;}
body.kc-css-system .kc-css-757130{margin-left:0%;width:100%;}
body.kc-css-system .kc-css-942737{width:100%;}
body.kc-css-system .kc-css-873504{margin-left:0%;width:100%;}
body.kc-css-system .kc-css-802933{width:100%;}
body.kc-css-system .kc-css-339992{margin-left:0%;width:100%;}
body.kc-css-system .kc-css-361435{width:100%;}
body.kc-css-system .kc-css-920217{margin-left:0%;width:100%;}
body.kc-css-system .kc-css-867326{width:100%;}
body.kc-css-system .kc-css-334574{margin-left:0%;width:100%;}
body.kc-css-system .kc-css-540748{width:100%;}
}
@media only screen and (max-width:479px){
body.kc-css-system .kc-css-909007{padding-top:80px;padding-bottom:80px;}
}
/*! CSS Used fontfaces */
@font-face{font-display:swap;font-family:'native';src:url(../../assets/fonts/native.eot?3hn4ip);src:url('../../assets/fonts/native.eot?3hn4ip#iefix') format('embedded-opentype'),url(../../assets/fonts/native.ttf?3hn4ip) format('truetype'),url(../../assets/fonts/native.woff?3hn4ip) format('woff'),url('../../assets/fonts/native.svg?3hn4ip#native') format('svg');font-weight:400;font-style:normal;}

</style>



// WEBPACK FOOTER //
// src/components/Views/Industries.vue